import { render, staticRenderFns } from "./ParentChildrenList.vue?vue&type=template&id=2de68c70&"
import script from "./ParentChildrenList.vue?vue&type=script&lang=js&"
export * from "./ParentChildrenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports